/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Chapter, Loader, Ticker } from "../../components";
import COLORS from "../../assets/styles/colors";
import {
  getCurrentChapter,
  getChapters,
  getTimelineLoading,
  getChapterStep,
} from "../../_entities/Timeline/Timeline.selectors";
import { getLogo } from "../../_entities/Containers/Containers.selectors";
import useChapterSlider from "../../hooks/useChapterSlider";
import {
  setChapterStep,
  setCurrentChapter,
} from "../../_entities/Timeline/Timeline.actions";
import { fetchSlides } from "../../_entities/Slides/Slides.actions";
import { getSlides } from "../../_entities/Slides/Slides.selectors";

const ChapterContainer = ({ history }) => {
  const dispatch = useDispatch();

  const logo = useSelector(getLogo);
  const loading = useSelector(getTimelineLoading);
  const chapters = useSelector(getChapters);
  const slides = useSelector(getSlides);
  const chapterStep = useSelector(getChapterStep);
  const currentChapter = useSelector(getCurrentChapter);
  const dispatchChapterStep = (step) => {
    dispatch(setChapterStep(step));
    dispatch(setCurrentChapter(chapters[step]));
  };

  const { nextChapter, chapter } = useChapterSlider(
    chapters,
    chapterStep,
    dispatchChapterStep
  );
  const loadSlides = useCallback(async () => {
    await dispatch(fetchSlides());
  }, [dispatch]);

  useEffect(() => {
    loadSlides();
  }, []);

  useEffect(() => {
    if (chapterStep + 1 === chapters?.length) {
      currentChapter?.step + 1 > currentChapter?.slides?.length &&
        history.push("/");
    }
  }, [chapterStep, chapters, currentChapter, history]);

  const loadedSlides = slides.filter((slide) =>
    chapter?.slides.includes(slide.id)
  );

  return (
    <div
      style={{
        backgroundColor: COLORS[Math.floor(Math.random() * COLORS.length)],
      }}
    >
      <Ticker />
      {loading ? (
        <Loader color="#000" />
      ) : (
        <>
          <Chapter
            index={chapters.findIndex((ch) => ch.id === chapter.id)}
            total={chapters?.length}
            logo={logo}
            {...chapter}
            loadedSlides={loadedSlides}
          />
        </>
      )}
    </div>
  );
};

export default ChapterContainer;
